module.exports = __webpack_public_path__ + "static/06.e4ec7791.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/visual/06.jpg
// module id = 367
// module chunks = 35783957827783